import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ConfigProvider } from 'antd'
import azAZ from 'antd/lib/locale/az_AZ'
import { MainRouter } from './router'
import { MeProvider } from './modules/me/context/context'
import { BrowserRouter } from 'react-router-dom'
import { EmergencyProvider } from './modules/settings/context'
import { TableCacheProvider } from '@shared/modules/next-table/context/table-cache'

export const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } } })

const App = () => {
  return (
    <ConfigProvider locale={azAZ}>
      <QueryClientProvider client={queryClient}>
        <MeProvider>
          <EmergencyProvider>
            <BrowserRouter>
              <TableCacheProvider>
                <MainRouter />
              </TableCacheProvider>
            </BrowserRouter>
          </EmergencyProvider>
        </MeProvider>
      </QueryClientProvider>
    </ConfigProvider>
  )
}

export default App
